<template>
  <section>
    <h5 class="text-gray-800 fw-bold mb-3">История обращения</h5>
    <div class="podft-history">
      <div class="podft-history__item" v-for="item in lists" :class="item.id === thisId ? 'this' : ''">
        <div class="p-4 mb-3 rounded border cursor-pointer" @click="getItem(item.id)" :class="item.id === thisId ? 'border-success' : ''">
          <span class="text-gray-800">
            <span class="badge badge-secondary">
              <span class="text-gray-800">{{item.id}}</span>
            </span>
          </span>&nbsp;
          <span class="text-gray-800">
            <span class="badge badge-secondary">
              <span class="text-gray-800">{{item.updated}} | <b v-html="item.updated_time"></b></span>
            </span>
          </span>&nbsp;
          <span class="text-gray-800">
            <span class="podft-status" :class="'status-'+item.status" v-html="item.statusName"></span>
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'PodftAsideModalHistory',
    props: {
      lists:  null,
      thisId: null
    },
    methods: {
      getItem(id) {
        this.$emit('getItem', id)
      }
    }
  }
</script>

<style scoped>

</style>